import { DIALOG_DATA } from '@angular/cdk/dialog';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MboIconDirective } from '@bo-ui/material/icon';

import { DialogComponent } from '../dialog/dialog.component';

import { ConfirmationDialogData } from './models/confirm-dialog-data.interface';

@Component({
  selector: 'crm-tgbot-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrl: './confirmation-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButton, MatIcon, MboIconDirective, DialogComponent],
})
export class ConfirmationDialogComponent {
  readonly data: ConfirmationDialogData = inject(DIALOG_DATA);

  private readonly dialogRef = inject(MatDialogRef<ConfirmationDialogComponent>);

  onClose(reason: boolean): void {
    this.dialogRef.close(reason);
  }
}
